import { tgxApi } from "../../app/tgxApi";
import { getAuthorizationHeader, handleQueryError } from "../../helpers/utils/RtkQueryUtils";

export const profileApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        utilData: build.query({
            query: () => ({
                url: `/utility/profile`,
                method: "GET",
                headers: getAuthorizationHeader()
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
            providesTags: ["utilData"],
        }),

        markListAsUnReadNotification: build.mutation({
            query: () => ({
                url: `/ajax/notifications/markListAsUnRead`,
                method: "PUT",
                headers: getAuthorizationHeader()
            }),
            invalidatesTags:["utilData"],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
           
        }),

        markListAsReadNotification: build.mutation({
            query: (id:any) => ({
                url: `/ajax/markAsRead/${id}`,
                method: "PUT",
                headers: getAuthorizationHeader()
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
           
        }),
        userProfileInfo: build.query({
            query: () => ({
                url: `/ajax/get-user-profile`,
                method: "GET",
                headers: getAuthorizationHeader()
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled)
            },
            providesTags: ["userProfileInfo"],
        }),
    })
});

export const {
    useUtilDataQuery,
    useUserProfileInfoQuery,
    useMarkListAsUnReadNotificationMutation,
    useMarkListAsReadNotificationMutation
 } = profileApi